import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    stockMaterialReportList: () => {
        return HTTP.get('/stock/mat_report', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    stockMaterialInOutReportList: (start_date,end_date) => {
        return HTTP.get('/stock/mat_in_out_report?first_date='+start_date+'&end_date='+end_date, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}